function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// eslint-disable-next-line import/prefer-default-export
export var getImageDataObject = function getImageDataObject(srcData, alt) {
  var isSrcDataObject = _typeof(srcData) === "object";
  return {
    src: isSrcDataObject ? srcData.src : srcData,
    srcSet: isSrcDataObject && srcData.retinaSrc ? "".concat(srcData.retinaSrc, " 2x") : undefined,
    width: isSrcDataObject ? srcData.width : undefined,
    height: isSrcDataObject ? srcData.height : undefined,
    title: isSrcDataObject ? srcData.title : undefined,
    alt: isSrcDataObject && srcData.alt ? srcData.alt : alt
  };
};